import { PlusCircle, ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate, useParams } from "react-router-dom";
import { Column } from "../../Components/Tables/Table";
import { header } from "../../Shared/Cards/Card.type";
import { prepareSearchColumns } from "../../Utility/Utility";
import { useEffect, useState } from "react";
import CommonConfirmationModal from "../../Components/Modals/CommonConfirmationModal";
import { ApiResponse } from "../../model/common/apiResponse";
import toast from "react-hot-toast";
import { changeStatus } from "../setup/service/setup.service";
import SetupList from "../setup/list/List";
import { CustomerOverviewProps } from "./model/customer.model";
import { deleteCustomer } from "./service/customer.service";
import useUserStore, { userAccess } from "../../store/auth/userStore";

export default function CustomerOverview() {
  const pageName = "Customers";
  const addUrl="/account/client/customer/add"
  const listUrl="/account/client/customer/list-view"
  const gridUrl="/account/client/customer/grid-view"
  const statusUpdateEndpoint = "customers"
  const ListingEndpoint="customers/query";

  const navigation=useNavigate();
  const { viewtype } = useParams<{ viewtype: string }>();
  const [statusData, setStatusData] = useState<any>();
  const [data, setData] = useState<any>(null);
  const [userAccess, setUserAccess] = useState<userAccess | null>(null);
  const { currentUser, fetchUser } = useUserStore();
  const [loading, setLoading] = useState(true);
  const [confirmModalData, setConfirmModalData] = useState({
    customer_id:0,
    showconfModal: false,
    message:''
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const handleconfShow = () => {
    setConfirmModalData((prevData) => ({
      ...prevData,
      showconfModal: true
    }));
  };
  const handleconfClose = () =>{
    setConfirmModalData({
      customer_id: 0,
      showconfModal: false,
      message: ``
    });
  }
  const handelEditAction = (data: any) => {
    navigation(`/account/client/customer/edit/${data.id}`);
  };

  useEffect(() => {
        setLoading(true);
        fetchUser().then((user: userAccess | null) => {
          setUserAccess(user);
        }).then(() => {
          setLoading(false);
        })
    }, [fetchUser])

  const onModalSubmit = (isAccept: boolean) => {
    if(confirmModalData.customer_id!==0 && isAccept){
      deleteCustomer(confirmModalData.customer_id).then((response:ApiResponse<any>) => {
        if (response.status==200) {
          toast.success("Customer deleted successfully");
          setRefreshTrigger(prev => prev + 1);
        } else {
          toast.error("Failed to delete customer");
        }
      });
    }
    handleconfClose();
  };
  const handelDeleteAction = (data: any) => {
    setConfirmModalData({
      customer_id: data.id,
      showconfModal: true,
      message:`Are you sure you want to delete customer '${data.name}'?`
    });
  }; 
  const handelInactiveAction = (data: any, isActive: boolean) => {
    const payload= {
    "is_active": isActive
    }
    changeStatus(`${statusUpdateEndpoint}/${data.id}`,payload).then((response:ApiResponse<any>) => {
          
      if(response.status==200){
        setStatusData(response.data);
        toast.success('Customer status updated successfully!', {
            duration: 5000,
          });
      }else{
        toast.error('Failed to update customer status!', {
            duration: 5000,
          });
      }
    

     })
  };
  let columns: Column[]
  if(viewtype === "list-view"){
     columns = [
      {
        name: "Code",
        selector: (row: CustomerOverviewProps) => (
          <span className="cursor-pointer text-primary" onClick={()=>getDetails(row)}>
              {row.code ? row.code : '-'}
          </span>
      ),
        
      },
      {
        name: "Name",
        selector: (row: CustomerOverviewProps) => row.name ? row.name : '-',
      },
      {
        name: "City",
        selector: (row:CustomerOverviewProps) => row.city ? row.city : '-',
      },
      {
        name: "State",
        selector: (row: CustomerOverviewProps) => row.state_province ? row.state_province : '-',
      },
      {
        name: "Status",
        selector: (row: CustomerOverviewProps) => {
          return row.is_active === 1 ? (
            <span className="badge text-bg-light border border-2 px-3 border-info-subtle">
                Active
            </span>
          ) : (
            <span className="badge text-bg-light border border-2 px-3 border-danger-subtle">
             Inactive
            </span>
          );
        },
      },
      {
        name: <></>,
        selector: (row: any) => (
          <>
            <span
              className="cursor-pointer dropdown-toggle action-menu"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <ThreeDotsVertical />
            </span>
            <ul className="dropdown-menu action-items">
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelEditAction(row)}
              >
                Edit
              </li>
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelInactiveAction(row, !row.is_active)}
              >
                 {row.is_active ? 'Inactive' : 'Active'}
              </li>
              {
                userAccess && userAccess?.is_spherewms_admin ? (
              <li
                className="cursor-pointer ms-3 mb-1"
                onClick={() => handelDeleteAction(row)}
              >
                Delete
              </li>
                ) : (
                  <></>
                )
              }
            </ul>
          </>
        ),
      },
    ];
  }else{
     columns= [
      {
        name: "Name",
        selector: (row: CustomerOverviewProps) => row.name,
      },
      {
        name: "City",
        selector: (row:CustomerOverviewProps) => row.city,
      },
      {
        name: "State",
        selector: (row: CustomerOverviewProps) => row.state_province,
      },
    ];
  }

  const headers: header[] = [
    {
      name: "Code",
      selector: (row: CustomerOverviewProps) => row.code,
    },
  ];
  const db_columns= [
    {
        "data": "customer.id"
    },
    {
        "data": "customer.code"
    },
    {
        "data": "customer.name"
    },
    {
      "data": "customer.city"
    },
    {
      "data": "customer.state_province"
    },
    {
      "data": "customer.is_active"
    }
];
  const exclude_columns:any = ["is_active"];
  const search_columns = exclude_columns?prepareSearchColumns(db_columns, exclude_columns):[];
  const sorting_order=[
    {
      column: "customer.id",
      dir: "desc",
    },
  ];
  const getDetails = (item: any) => {
    navigation(`/account/client/customer/details/${item.id}`);
  };
  


  const handleDataChange = (data: any) => {
    setData(data);
  };

  return (
    <>
   <SetupList 
    pageName={pageName}
    columns={columns}
    addUrl={addUrl}
    listUrl={listUrl}
    gridUrl={gridUrl}
    viewtype={viewtype || "grid-view"}
    headers={headers}
    getDetails={getDetails}
    search_columns={search_columns}
    db_columns={db_columns}
    update_status_url={statusUpdateEndpoint}
    statusData={statusData}
    setStatusData={setStatusData}
    onDataChange={handleDataChange}
    data={data}
    refreshTrigger={refreshTrigger}
    handelEditAction={handelEditAction}
    listEndpoint={ListingEndpoint}
    sorting_order={sorting_order}
    />
        <CommonConfirmationModal
        customClassName="header-border"
        show={confirmModalData.showconfModal}
        confirmBtnText="YES"
        cancelBtnText="NO"
        content={<> {confirmModalData.message} </>}
        onModalSubmit={onModalSubmit}
      />
    </>
)
}
